import React from 'react';

import { ChurchProfile } from '@/components/AccountPanel/components/ChurchProfile';
import { IndexIndicator } from '@/components/shared/IndexIndicator';
import { UserMilestones } from '@/config/constants';
import { classNames } from '@/helpers/classNames';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { useAuth } from '@/providers/AuthProvider';

import { OnboardingContext } from './Onboarding';
import styles from './Onboarding.module.scss';

const StepFour = () => {
	const { setStep, step, shouldAddService, completedStepIndices } =
		React.useContext(OnboardingContext);
	const { updateUser } = useAuth();
	const fireSaveChurchProfile = useAnalyticsEvent('Onboarding_Step4_Save_Church_Profile');

	return (
		<ChurchProfile
			hasBack
			actionLabel="Next"
			bottomActionProps={{
				className: styles['layout'],
				contentClassName: styles['step-three'],
				topContent: (
					<IndexIndicator
						className={styles['indicator']}
						dotClassName={styles['dot']}
						total={6}
						current={2}
						variant="stretched"
						onIndicatorClick={(i) => setStep(i + 2)}
						hasHover
						conditionalItems={[
							{ index: 3, visible: shouldAddService },
						]}
						disabledItems={[{ index: 5, enabled: false }]}
					hasDataItems={completedStepIndices}
					/>
				),
			}}
			onBack={() => {
				setStep(step - 1);
			}}
			onSave={() => {
				fireSaveChurchProfile();
				setStep(shouldAddService ? 5 : 6);
			}}
			leadingContent={
				<div className={styles['title-header']}>
					<div className={styles['heading']}>About your church</div>
					<div className={classNames([styles['text'], 'mt-sm'])}>
						This helps Asaph understand your church.
					</div>
				</div>
			}
		/>
	);
};

export default StepFour;
